export const BASE_PATH = '/asiointi'

export const taskPath = {
  terminateContract: 'irtisano',
  modificationContract: 'sopimusmuutos',
  residentChanges: 'asukasmuutokset',
  messages: 'viestit',
  parking: 'pysakointi',
  storages: 'varastot',
  defectNotice: 'vikailmoitus',
  question: 'kysymys',
  feedback: 'palaute',
  payments: 'maksut',
  documents: 'dokumentit',
  bulletins: 'tiedotteet',
  bulletinBoard: 'kaikki-tiedotteet',
  contactInfo: 'yhteystiedot',
  laundryReservations: 'pesulavaraukset',
  saunaReservations: 'saunavaraukset',
  gymReservations: 'kuntosalivaraukset',
  gymBooking: 'kuntosalivuorot',
  commonAreaReservations: 'kokoontumistilat',
} as const

const routePath = {
  root: '/',
  frontPage: `${BASE_PATH}/:contractId`,
  terminateContract: `${BASE_PATH}/:contractId/${taskPath.terminateContract}`,
  confirmContractTermination: `${BASE_PATH}/:contractId/${taskPath.terminateContract}/vahvista`,
  confirmContractModification: `${BASE_PATH}/:contractId/${taskPath.modificationContract}/vahvista`,
  residentChanges: `${BASE_PATH}/:contractId/${taskPath.residentChanges}`,
  parking: `${BASE_PATH}/:contractId/${taskPath.parking}`,
  storages: `${BASE_PATH}/:contractId/${taskPath.storages}`,
  messages: `${BASE_PATH}/:contractId/${taskPath.messages}`,
  messageThread: `${BASE_PATH}/:contractId/${taskPath.messages}/:messageThreadUuid`,
  defectNotice: `${BASE_PATH}/:contractId/${taskPath.defectNotice}`,
  defectNoticeEdit: `${BASE_PATH}/:contractId/${taskPath.defectNotice}/:defectNoticeUuid`,
  feedbackView: `${BASE_PATH}/:contractId/${taskPath.feedback}/:feedbackQuestionNoticeUuid`,
  questionView: `${BASE_PATH}/:contractId/${taskPath.question}/:feedbackQuestionNoticeUuid`,
  question: `${BASE_PATH}/:contractId/${taskPath.question}`,
  feedback: `${BASE_PATH}/:contractId/${taskPath.feedback}`,
  paymentInfo: `${BASE_PATH}/:contractId/${taskPath.payments}/tiedot`,
  paymentHistory: `${BASE_PATH}/:contractId/${taskPath.payments}/historia`,
  rightOfOccupancyFee: `${BASE_PATH}/:contractId/${taskPath.payments}/asumisoikeusmaksu`,
  userInfo: '/omat-tiedot/:contractId',
  notFound404: '/404',
  notFoundRedirect: '*',
  login: '/login',
  logout: '/logout',
  register: '/register',
  registerFtnCallbackError: '/register/ftn-callback-error',
  registerChooseAuth: '/register/chooseAuth',
  registerAuth: '/register/auth',
  forgotPassword: '/password/forgot',
  setPassword: '/set-password',
  verifyEmail: '/register/verify-email',
  invitation: '/invitations/:uuid',
  documents: `${BASE_PATH}/:contractId/${taskPath.documents}`,
  strongAuthUserManagement: '/register/user-management',
  bulletin: `${BASE_PATH}/:contractId/${taskPath.bulletins}/:bulletinUuid`,
  building: `${BASE_PATH}/:contractId/kiinteiston-tiedot`,
  bulletinBoard: `${BASE_PATH}/:contractId/${taskPath.bulletinBoard}`,
  bulletinBoardBulletin: `${BASE_PATH}/:contractId/${taskPath.bulletinBoard}/:bulletinUuid`,
  contactInfo: `${BASE_PATH}/:contractId/${taskPath.contactInfo}`,
  laundryReservations: `${BASE_PATH}/:contractId/${taskPath.laundryReservations}`,
  saunaReservations: `${BASE_PATH}/:contractId/${taskPath.saunaReservations}`,
  gymBooking: `${BASE_PATH}/:contractId/${taskPath.gymBooking}`,
  gymReservations: `${BASE_PATH}/:contractId/${taskPath.gymReservations}`,
  commonAreaReservations: `${BASE_PATH}/:contractId/${taskPath.commonAreaReservations}`,
} as const

export const makeContractFrontPageURL = (contractUuid: string) =>
  routePath.frontPage.replace(':contractId', contractUuid)

export default routePath
